import {darkerGreenColor, redColor} from '../../styles/style';
import cardsStyle from '../../styles/components/cards';

const style = {
  cellContainer: {
    textAlign: 'center',
  },
  usersOnline: {
    color: darkerGreenColor,
  },
  usersOffline: {
    color: redColor,
  },
  table__header: {
    textAlign: 'center !important',
  },
  table__action: {
    margin: 0,
  },
  personasTable__table: {
    'height': 'calc(100vh - 250px)',
    '@media (max-width: 640px)': {
      height: 'calc(100vh - 360px)',
    },
  },
  personasTable__tbodyInfinite: {
    display: 'block',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: 'calc(100vh - 275px)',
    minWidth: 'max-content',
  },
  tbodyInfinite_noItems: {
    height: 'calc(100vh - 275px)',
  },
  personasTableCard: {
    ...cardsStyle.card,
  },
  personasTableCard__header: {
    ...cardsStyle.card__header,
  },
  personasTableCard__title: {
    ...cardsStyle.card__title,
    ...cardsStyle.card__title_primary,
    borderBottom: 'none',
  },
  personasTableCard__content: {
    ...cardsStyle.card__content,
    padding: '0px 20px 5px 20px !important',
  },
};

export default style;
